import { s as e, _ as t } from "./chunk-JJ6VZ5V7-dcb0df39.mjs";
import * as l from "react";
import { s as d, c } from "./lib-ed2ec51e.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var v = (a) => /* @__PURE__ */ l.createElement(
  "svg",
  t({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, a),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M10.667.314v31.372c-1.733-.204-3.255-.508-4.325-.916C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 1.03-4.918 5.476-6.646C7.412.821 8.934.518 10.667.314Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M21.333.318v31.38c-1.654.19-3.502.286-5.333.302a50.558 50.558 0 0 1-5.334-.314V.314A50.525 50.525 0 0 1 16 0c1.83.016 3.676.12 5.333.318Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M21.334 31.698V.318c1.738.207 3.27.52 4.357.945 4.447 1.728 5.476 6.646 5.476 6.646.664 2.757.863 5.582.83 8.107.033 2.493-.2 5.317-.863 8.108 0 0-1.029 4.918-5.477 6.646-1.07.425-2.59.728-4.323.928Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "#FFE7AA",
      fillRule: "evenodd",
      d: "M16.129 21.28a.333.333 0 0 1-.258 0l-1.076-.452a.333.333 0 0 1-.196-.233l-.077-.336a.333.333 0 0 0-.325-.259h-1.485a.333.333 0 0 1-.152-.037l-1.046-.537a.333.333 0 0 1-.18-.296v-1.61c0-.095.04-.185.11-.248l.45-.406a.333.333 0 0 0 .054-.432l-.559-.84a.334.334 0 0 1-.055-.184v-1.125c0-.137.084-.26.212-.31l.502-.197a.332.332 0 0 0 .131-.528l-.583-.677a.332.332 0 0 1 .084-.505l1.082-.63a.333.333 0 0 1 .352.01l.894.596a.333.333 0 0 0 .518-.296l-.032-.54a.333.333 0 0 1 .465-.326l.909.394a.33.33 0 0 0 .265 0l.908-.394a.333.333 0 0 1 .465.325l-.031.54a.333.333 0 0 0 .517.297l.894-.595a.333.333 0 0 1 .353-.011l1.081.63a.333.333 0 0 1 .085.506l-.584.676a.334.334 0 0 0 .131.528l.503.196c.128.05.212.174.212.31v1.126c0 .066-.02.13-.056.185l-.559.839a.333.333 0 0 0 .054.432l.45.406c.07.063.11.153.11.248v1.61a.33.33 0 0 1-.18.296l-1.045.537a.333.333 0 0 1-.152.037h-1.486a.333.333 0 0 0-.325.259l-.077.336a.333.333 0 0 1-.196.233l-1.076.451Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M19.333 18.482s0 .087-.007.142c-.02.16-.045.251-.113.395a1.07 1.07 0 0 1-.226.324 1.07 1.07 0 0 1-.315.233c-.13.07-.213.091-.355.125a1.715 1.715 0 0 1-.372.049c-.133.006-.21 0-.343-.01-.142-.01-.222-.031-.364-.044-.118-.011-.185-.021-.303-.02a1.473 1.473 0 0 0-.59.105c-.146.062-.31.17-.345.219-.035-.048-.2-.157-.345-.219a1.472 1.472 0 0 0-.59-.106c-.119 0-.185.01-.303.02-.143.014-.222.035-.365.046-.133.01-.209.015-.343.009a1.717 1.717 0 0 1-.371-.049 1.284 1.284 0 0 1-.355-.125 1.064 1.064 0 0 1-.315-.233 1.07 1.07 0 0 1-.226-.324 1.124 1.124 0 0 1-.113-.395 1.472 1.472 0 0 1-.008-.142v-5.815h6.665v5.815h.002Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "#E94B35",
      d: "M16 19.584c.576-.39 1.15-.202 1.819-.167.54.028 1.179-.264 1.179-.862V13H13v5.555c0 .598.64.89 1.18.862.667-.035 1.247-.224 1.82.167Z"
    }
  ),
  /* @__PURE__ */ l.createElement("path", { fill: "#F2C500", d: "M16.666 13h.667v3h-.667zM18 13h.667v3H18z" }),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M14 16.333v3.082a1.32 1.32 0 0 1-.666-.23v-2.852H14Zm1.334 0v3.016c-.216-.02-.437 0-.667.024v-3.04h.667Zm.832 3.153v-3.153H19v2.222c0 .598-.64.89-1.18.862-.603-.032-1.134-.189-1.654.07ZM13.8 15.354h1.067l.466-1.02-1-1.012-1 1.011.467 1.02Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M17.173 16.782a.036.036 0 0 0 .031.056l1.017-.022a.112.112 0 0 1 .077.197l-.005.004a.121.121 0 0 0-.041.091v.078c0 .03.008.06.023.087a.17.17 0 0 1 .019.128l-.06.247a.048.048 0 1 1-.09-.033l.037-.078a.071.071 0 0 0-.121-.075l-.105.139a.061.061 0 1 1-.093-.079l.025-.028a.091.091 0 0 0-.064-.152l-.194-.005a.178.178 0 0 0-.18.152l-.017.112a.067.067 0 0 1-.133-.014l.01-.18a.08.08 0 0 0-.071-.084h-.005a.07.07 0 0 0-.053.016l-.007.007a.06.06 0 0 0-.002.089l.002.002a.055.055 0 1 1-.087.066l-.045-.086a.106.106 0 0 1 .003-.105l.004-.008a.122.122 0 0 0 .013-.1l-.009-.028a.184.184 0 0 0-.127-.122l-.178-.05a.085.085 0 0 1-.034-.145l.134-.119a.153.153 0 0 1 .12-.037l.18.023c.026.004.04.034.026.056Zm0 1.333a.036.036 0 0 0 .031.056l1.017-.021a.112.112 0 0 1 .077.196l-.005.004a.121.121 0 0 0-.041.091v.078c0 .03.008.06.023.087a.17.17 0 0 1 .019.128l-.06.247a.048.048 0 1 1-.09-.033l.037-.078a.071.071 0 0 0-.121-.074l-.105.138a.061.061 0 1 1-.093-.078l.025-.028a.091.091 0 0 0-.064-.153l-.194-.005a.178.178 0 0 0-.18.153l-.017.111a.067.067 0 0 1-.133-.014l.01-.179a.08.08 0 0 0-.071-.084l-.005-.001a.069.069 0 0 0-.053.017l-.007.006a.06.06 0 0 0-.002.089l.002.003a.055.055 0 1 1-.087.066l-.045-.086a.106.106 0 0 1 .003-.106l.004-.008a.122.122 0 0 0 .013-.1l-.009-.027a.184.184 0 0 0-.127-.122l-.178-.05a.086.086 0 0 1-.034-.146l.134-.119a.152.152 0 0 1 .12-.037l.18.024c.026.003.04.033.026.055Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M12.666 16h6.667v.333h-6.667z" }),
  /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M15.666 12.845h.667v6.802h-.667z" })
), i = d(v)`
  ${e}
  ${c}
`, M = i;
export {
  M as default
};
